import DOMPurify from "dompurify";

export function MiniMarkdown({ text }) {
  const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const inline = (s) => DOMPurify.sanitize(
    esc(s)
      .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
      .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-cyan-400 underline">$1</a>'),
    { ALLOWED_TAGS: ["strong", "a", "em"], ALLOWED_ATTR: ["href", "target", "rel", "class"] }
  );
  const blocks = [];
  let list = null;
  (text || "").split("\n").forEach((ln) => {
    const m = ln.match(/^\s*[-*]\s+(.*)/);
    if (m) { (list = list || []).push(m[1]); }
    else { if (list) { blocks.push({ t: "ul", items: list }); list = null; } blocks.push({ t: "p", text: ln }); }
  });
  if (list) blocks.push({ t: "ul", items: list });
  return <div className="text-[13px] text-slate-200 space-y-1" data-testid="comment-body">{blocks.map((b, i) => b.t === "ul"
    ? <ul key={i} className="list-disc pl-5 space-y-0.5">{b.items.map((it, j) => <li key={j} dangerouslySetInnerHTML={{ __html: inline(it) }} />)}</ul>
    : <p key={i} className="whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: inline(b.text) }} />)}</div>;
}
